import { FormControl } from '@angular/forms';
export enum TfaConfirmationControlName {
  Code = 'code',
}

export interface TfaConfirmationFormGroup {
  [TfaConfirmationControlName.Code]: FormControl<string>;
}
